/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = 7Eo7
// module chunks = 4